<!--
 * @Author: wangping wangping@gdtwzc.com
 * @Date: 2023-10-12 14:07:58
 * @LastEditors: wp 1683997498@qq.com
 * @LastEditTime: 2024-07-24 10:50:47
 * @FilePath: \twzc004-h5\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <router-view v-slot="{ Component }">
    <transition>
      <keep-alive v-if="$route.meta.keepAlive">
        <component :is="Component" />
      </keep-alive>
      <component v-else :is="Component" />
    </transition>
  </router-view>
</template>
<script setup>
import { ref, onMounted, computed } from "vue";
onMounted(() => {
  document.getElementsByTagName("input").onblur = window.scrollTo(0, 0);
})
</script>
<style lang="" scoped></style>

<!-- <template>
  <div>
    <div @click="recOpen">获取权限</div>
    <div @touchstart="recStart"
            @touchmove="onTouchmove"
            @touchend="recStop"
    >{{ aa1 }}</div>
    <div @click="start">获取权限并且录音</div>
    <div @click="recStop">播放</div>
  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue'
import Recorder from 'recorder-core';
import dazhaohu from "@/assets/video/dazhaohu.pcm";
let stream,testType,testDecode,testTransform,ctx,testAllPcm,testInfo,testSampleRate;
var rec,wave;

const aa1 = ref('开始按钮')
onMounted(()=>{
document.addEventListener("contextmenu", function (e) {
      e.preventDefault();
    });

    document.addEventListener("selectstart", function (e) {
      e.preventDefault();
    });
  })
/**调用open打开录音请求好录音权限**/
var recOpen=function(success){//一般在显示出录音按钮或相关的录音界面时进行此方法调用，后面用户点击开始录音时就能畅通无阻了
    rec=Recorder({ //本配置参数请参考下面的文档，有详细介绍
        type:"mp3",sampleRate:16000,bitRate:16 //mp3格式，指定采样率hz、比特率kbps，其他参数使用默认配置；注意：是数字的参数必须提供数字，不要用字符串；需要使用的type类型，需提前把格式支持文件加载进来，比如使用wav格式需要提前加载wav.js编码引擎
        ,onProcess:function(buffers,powerLevel,bufferDuration,bufferSampleRate,newBufferIdx,asyncEnd){
            //录音实时回调，大约1秒调用12次本回调，buffers为开始到现在的所有录音pcm数据块(16位小端LE)
            //可利用extensions/sonic.js插件实时变速变调，此插件计算量巨大，onProcess需要返回true开启异步模式
            //可实时上传（发送）数据，配合Recorder.SampleData方法，将buffers中的新数据连续的转换成pcm上传，或使用mock方法将新数据连续的转码成其他格式上传，可以参考文档里面的：Demo片段列表 -> 实时转码并上传-通用版；基于本功能可以做到：实时转发数据、实时保存数据、实时语音识别（ASR）等

            //可实时绘制波形（extensions目录内的waveview.js、wavesurfer.view.js、frequency.histogram.view.js插件功能）
            wave&&wave.input(buffers[buffers.length-1],powerLevel,bufferSampleRate);
        }
    });

    rec.open(function(){//打开麦克风授权获得相关资源
      // console.log("麦克风授权成功",success());
        //rec.start() 此处可以立即开始录音，但不建议这样编写，因为open是一个延迟漫长的操作，通过两次用户操作来分别调用open和start是推荐的最佳流程

        //创建可视化，指定一个要显示的div
        // if(Recorder.WaveView)wave=Recorder.WaveView({elem:".recwave"});
        // success&&success();
    },function(msg,isUserNotAllow){//用户拒绝未授权或不支持
        console.log((isUserNotAllow?"UserNotAllow，":"")+"无法录音:"+msg);
    });


};


/**开始录音**/
function recStart(){//打开了录音后才能进行start、stop调用
  aa1.value = '按下录音按钮'
  console.log('开始录音');
    rec.start();

};
const start = () => {
  recOpen(function() {//打开录音权限后开始录音
    recStart();
  });
}

/**结束录音**/
function recStop(){
  aa1.value = '结束'
    // rec.stop(function(blob,duration){
        
    //     //简单利用URL生成本地文件地址，注意不用了时需要revokeObjectURL，否则霸占内存
    //     //此地址只能本地使用，比如赋值给audio.src进行播放，赋值给a.href然后a.click()进行下载（a需提供download="xxx.mp3"属性）
    //     var localUrl=(window.URL||webkitURL).createObjectURL(blob);
    //     console.log(blob,localUrl,"时长:"+duration+"ms");
    //     rec.close();//释放录音资源，当然可以不释放，后面可以连续调用start；但不释放时系统或浏览器会一直提示在录音，最佳操作是录完就close掉
    //     rec=null;
        
    //     //已经拿到blob文件对象想干嘛就干嘛：立即播放、上传、下载保存
        
    //     /*** 【立即播放例子】 ***/
    //     var audio=document.createElement("audio");
    //     document.body.prepend(audio);
    //     audio.controls=true;
    //     audio.src=localUrl;
    //     audio.play();
    // },function(msg){
    //     console.log("录音失败:"+msg);
    //     rec.close();//可以通过stop方法的第3个参数来自动调用close
    //     rec=null;
    // });
    rec?.close();
    Recorder.Destroy()
    startPcm()
    ctx = Recorder.GetContext(true)
    start1()
    setRealtimeOff()
  setTimeout(() => {

   

    fetch(dazhaohu)
          .then((response) => response.arrayBuffer())
          .then((arrayBuffer) => {
            // console.log(arrayBuffer, "arrayBuffer");
            setTimeout(() => {
              receiveAudioChunk(arrayBuffer);
              setTimeout(() => {
              receiveAudioChunk(arrayBuffer);
            }, 5000);
            }, 500);
          });
  }, 1000)
};

const aa = () => {
  startPcm()
    ctx = Recorder.GetContext(true)
    start1()
    setRealtimeOff()
   

    fetch(dazhaohu)
          .then((response) => response.arrayBuffer())
          .then((arrayBuffer) => {
            // console.log(arrayBuffer, "arrayBuffer");
            setTimeout(() => {
              receiveAudioChunk(arrayBuffer);
               setTimeout(() => {
              receiveAudioChunk(arrayBuffer);

               }, 5000)
            }, 500);
          });


          
}

const startPcm = () => {
      testType = "pcm";
      let loadPcmSampleRate = 16000; //pcm的采样率
      testDecode = false; //pcm无需解码，但必须将输入转换成pcm[Int16,...]
      testTransform = function (arrayBuffer, sampleRate, True, False) {
        //pcm需指定sampleRate，为传输过来pcm的采样率
        True(new Int16Array(arrayBuffer), loadPcmSampleRate);
      };
    }
    const start1 = () => {
      if (stream) {
        console.log('存在stop');
        stop();
      }

      WS_Open();
      testAllPcm = [];
      testInfo = {};
      stream = Recorder.BufferStreamPlayer({
        decode: testDecode, //传输过来的不是pcm就需要开启解码
        onInputError: function (errMsg, inputIndex) {
          // Runtime.Log("第"+inputIndex+"次的音频片段input输入出错: "+errMsg,1);
        },
        onUpdateTime: function () {},
        onPlayEnd: async function () {
          console.log(
            "没有可播放的数据了，缓冲中 或者 已播放完成1111",
            "#aaa",
            stream.duration
          );
          //1213 请您耐心等候  打招呼：6375
          // if (!that.stream.isStop && that.stream.duration != 1213 && that.stream.duration != 6375) {
          //   console.log(
          //     "没有可播放的数据了，缓冲中 或者 已播放完成",
          //     "#aaa",
          //     that.stream.duration
          //   );
          //   if (that.currentIndex >= that.requestQueue.length) {
          //     that.handleAudioEnded();
          //     console.log(that.$refs.logRef,'that.$refs.logRef');
          //     that.$refs.logRef.setVoiceStatus(false);
          //     // stream.stop();
          //   }
          // }else if(that.stream.duration == 6375){
          //   that.$refs.standby_zhongshan.currentTime = 0;
          //   that.$refs.standby_shenzhen.currentTime = 0;
          //   if (that.currentPosition == "zhongshan") {
          //     that.$refs.standby_zhongshan.style.zIndex = "2";
          //     that.zhongshanPause()
          //   } else {
          //     that.$refs.standby_shenzhen.style.zIndex = "2";
          //     that.shengzhenPause()
          //   }
          // }else if(that.stream.duration == 1213){//请您耐心等候
          //   console.log('请您耐心等候结束');
          //   // that.recClose();
          // }
        },
        transform: function (pcm, sampleRate, True, False) {
          testTransform(
            pcm,
            sampleRate,
            function (pcm, sampleRate) {
              True(pcm, sampleRate);

              testSampleRate = sampleRate;
              testAllPcm.push(pcm); //另存一份 结束时转成一个完整音频 对比接收到的数据音质
            },
            False
          );
        },
        runningContent:ctx,
        // runningContext:function(aa){
        //   console.log(aa);
        // }
      });

      stream.start(
        function () {
          // Runtime.Log("stream已打开["+testType+"]，正在播放中",2);
          // recStart();//调用Recorder连接到这个stream进行可视化绘制
        },
        function (err) {
          // Runtime.Log("开始失败："+err,1);
        }
      );
    }
    const stop = () => {
      // WS_Close();
      // recStop();

      if (stream) {
        stream.stop();
      }
      stream = 0;
      // Runtime.Log("已结束");

      //生成一份完整的音频，对比音质
      var oldType = testType;
      var data = Recorder.SampleData(
        testAllPcm,
        testSampleRate,
        testSampleRate
      );
      var recMock = Recorder({ 
        type: "wav",
         sampleRate: testSampleRate});
      recMock.mock(data.data, testSampleRate);
      recMock.stop(function (blob, duration) {
        console.log(
          blob,
          duration,
          recMock,
          "接收到的所有" + oldType + "数据生成的完整文件"
        );
      });
    }
    const setRealtimeOff = () => {
      if (stream) {
        stream.set.realtime = false;
        // Runtime.Log("切换成了非实时模式，所有输入的数据都会按顺序完整的播放");
      }
    }
    const receiveAudioChunk = (arrayBuffer) => {
      if (stream && !testInfo.receivePause) {
        testInfo.count = (testInfo.count || 0) + 1;
        var allSize = (testInfo.allSize =
          (testInfo.allSize || 0) + arrayBuffer.byteLength);
        if (allSize < 1024 * 900) {
          allSize = (allSize / 1024).toFixed(2) + "KB";
        } else {
          allSize = (allSize / 1024 / 1024).toFixed(2) + "MB";
        }
        console.log(arrayBuffer, "接收到的音频数据", stream);

        stream.input(arrayBuffer);
      }
    }
    const WS_Open = () => {
      //ws.binaryType="arraybuffer";
      WS_Close();
    }
    const WS_Close=()=> {
      clearTimeout(window.wsInt);
    }
</script> -->